module.exports = __webpack_public_path__ + "img/logo.60b0fd9e.png";